import Icon from '../../components/Icon.vue'

Icon.register({"regular/file-audio":{"width":384,"height":512,"paths":[{"d":"M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM192 388C192 398.7 179.1 404 171.5 396.5L136 360.5H108C101.4 360.5 96 355.1 96 348.5V292.5C96 285.9 101.4 280.5 108 280.5H136L171.5 243.5C179.1 236 192 241.3 192 252V388zM233.2 340.8C242.3 331.5 242.3 316.7 233.2 307.4 211.1 284.7 245.4 251.2 267.6 273.9 294.8 301.9 294.8 346.4 267.6 374.3 245.8 396.7 210.7 364 233.2 340.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/file-audio.js
// module id = null
// module chunks = 